import "./../styles/join.css";
import React from 'react';
const CompanyProfile = () => {
  const employments = [
    {
      position: "销售专员",
      location: "江苏各地市  ",
      education: "本科",
      count: "不限",
      requirement:
        "1、负责区域市场的开拓与维护，建立良好的客户关系。 \n" +
        "2、推广公司产品，提供专业的产品咨询与服务。 \n" +
        "3、参与项目集成，协调客户需求与实施过程。\n " +
        "4、收集市场信息，分析行业动态，制订有效的市场策略。 \n" +
        "5、达成销售目标，定期汇报销售进展与市场反馈。\n" +
        "6、其他市场工作。",
      work:
        "1、本科及以上学历，市场营销、工商管理等相关专业优先。\n" +
        "2、1年以上销售经验，有相关行业背景者优先。\n" +
        "3、具备出色的沟通能力和销售技巧。\n" +
        "4、热爱销售工作，抗压能力强，责任心强。\n" +
        "5、有团队合作精神，能迅速融入团队。",
    },
    {
      position: "测绘内业工程师",
      location: "南京",
      education: "本科",
      count: "不限",
      requirement:
        "1、负责测绘项目内业数据加工制作。\n " +
        "2、负责测绘项目地址数据清洗治理。 \n" +
        "3、负责测绘项目数据质量控制。\n " +
        "4、负责对内业数据处理人员培训工作。\n " +
        "5、负责外包数据质量、进度、成本控制。\n" +
        "6、负责编写数据处理方案及数据质量控制方案。\n " +
        "7、负责将开发需求编写及测绘软件测试工作。\n " +
        "8、负责公司安排其他测绘相关工作。",
      work:
        "1、测绘地理信息中级工程师职称、本科学历。\n" +
        "2、5年以上相关工作经验。\n" +
        "3、熟练使用QGIS、ArcGIS、CAD等制图软件。",
    },
  ];
  return (
    <div className="join">
      <img src="/assets/join.png" alt="加入我们" />
      <div className="title">
        <div className="titleBefore">招聘岗位</div>
        <div className="titleEnd">POSITIONS</div>
        <div className="temp"></div>
      </div>
      <div className="employment">
        {employments.map((employment, index) => (
          <div className="employmentItem" key={index}>
            <div className="employment-title">{employment.position}</div>
            <div className="employment-info">
              <div className="employment-info-item">
                <img src="/assets/location.png" alt="工作地点" />
                <div className="employment-info-item-content">
                  {employment.location}
                </div>
              </div>
              <div className="employment-info-item">
                <img src="/assets/educatiom.png" alt="学历要求" />
                <div className="employment-info-item-content">
                  {employment.education}
                </div>
              </div>
              {/* <div className="employment-info-item">
                <img src="/assets/count.png" alt="招聘人数" />
                <div className="employment-info-item-content">
                  {employment.count} 人
                </div>
              </div> */}
            </div>
            <div className="employment-content">
              <div className="employment-content-title">岗位职责</div>
              <div className="employment-content-content">
                {employment.requirement}
              </div>

              <div className="employment-content-title">岗位要求</div>
              <div className="employment-content-content">
                {employment.work}
              </div>
            </div>
            <div className="line"></div>
            <div className="sendEmail">
              <div className="sendEmail-title">简历请投至该邮箱：</div>
              <div className="sendEmail-content"> ywsz@ywsz.net.cn</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default CompanyProfile;
